export default __webpack_public_path__ + "static/img-what-is-ml-a6adedf89fbd2d4a05b5cb5daff8227f.webp";